import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { getCurrentDate } from "../../Utilitie";
import AddNewType from "./AddNewType";

const PathWastageinsertion = ({
  stations,
  machineData,
  filteredReason,
  rawMData,
  addNewType,
  setAddNewType,
  setDataUpdated,
}) => {
  const [selectedDate, setSelectedDate] = useState(getCurrentDate());
  const urlBlockPrefix = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const keys = [
    "PT_TYPE",
    "PT_FROM",
    "PT_TO",
    "PT_REASON",
    "PT_WASTAGE_NUM",
    "PT_WASTAGE_TRAIN_TYPE",
    "REMARK",
  ];

  const options = {
    PT_TYPE: machineData,
    PT_FROM: [...new Set(stations.map((e) => e.station_code))],
    PT_TO: [...new Set(stations.map((e) => e.station_code))],
    PT_REASON: [...filteredReason.map((o) => o.table_option_for_insertion)],
    PT_WASTAGE_TRAIN_TYPE: [
      "Goods Train",
      "Passenger Train",
      "Mail/Exp Train",
      "Superfast Train",
    ],
  };

  const getEmptyRow = () => ({
    PT_DATE: selectedDate,
    PT_TYPE: "",
    PT_FROM: "",
    PT_TO: "",
    PT_REASON: "",
    PT_WASTAGE_NUM: "",
    PT_WASTAGE_TRAIN_TYPE: "",
    REMARK: "",
  });

  const [rows, setRows] = useState([getEmptyRow()]);
  useEffect(() => {
    rows.map((obj) => {
      obj["PT_DATE"] = selectedDate;
    });
  }, [selectedDate]);
  const [dropdownStates, setDropdownStates] = useState([
    {
      ptTypeDropdownOpen: false,
      ptFromDropdownOpen: false,
      ptToDropdownOpen: false,
      searchQuery: "",
      toStation: "",
      fromStation: "",
    },
  ]);

  const toggleCheckbox = (rowIndex, key, value) => {
    setRows((prevRows) =>
      prevRows.map((row, i) => {
        if (i !== rowIndex) return row;

        if (key === "PT_REASON" || key === "PT_WASTAGE_TRAIN_TYPE") {
          return { ...row, [key]: value };
        }

        const currentValues = row[key] ? row[key].split(",") : [];
        const updatedValues = currentValues.includes(value)
          ? currentValues.filter((v) => v !== value)
          : [...currentValues, value];

        return { ...row, [key]: updatedValues.join(",") };
      })
    );
  };

  const handleChange = (rowIndex, key, value) => {
    setRows((prevRows) =>
      prevRows.map((row, i) =>
        i === rowIndex ? { ...row, [key]: value } : row
      )
    );
  };

  const toggleDropdown = (rowIndex, dropdownKey, value) => {
    setDropdownStates((prevStates) =>
      prevStates.map((state, i) =>
        i === rowIndex ? { ...state, [dropdownKey]: value } : state
      )
    );
  };

  const setSearchQuery = (rowIndex, value, key) => {
    if (key === "PT_FROM") {
      setDropdownStates((prevStates) =>
        prevStates.map((state, i) =>
          i === rowIndex ? { ...state, fromStation: value } : state
        )
      );
    } else if (key === "PT_TO") {
      setDropdownStates((prevStates) =>
        prevStates.map((state, i) =>
          i === rowIndex ? { ...state, toStation: value } : state
        )
      );
    } else {
      setDropdownStates((prevStates) =>
        prevStates.map((state, i) =>
          i === rowIndex ? { ...state, searchQuery: value } : state
        )
      );
    }
  };

  const renderInput = (rowIndex, key) => {
    const row = rows[rowIndex];
    const dropdownState = dropdownStates[rowIndex] || {};
    switch (key) {
      case "PT_WASTAGE_NUM":
        return (
          <input
            type="number"
            className="form-control"
            value={row[key]}
            onChange={(e) => handleChange(rowIndex, key, e.target.value)}
          />
        );

      case "PT_TYPE": {
        const filteredTypeOptions = options.PT_TYPE.filter((opt) =>
          opt
            .toLowerCase()
            .includes((dropdownState.searchQuery || "").toLowerCase())
        );

        return (
          <div className="dropdown" onClick={(e) => e.stopPropagation()}>
            <button
              className="btn btn-outline-secondary dropdown-toggle w-100 text-start"
              type="button"
              onClick={() =>
                toggleDropdown(
                  rowIndex,
                  "ptTypeDropdownOpen",
                  !dropdownState.ptTypeDropdownOpen
                )
              }
            >
              <span
                className="d-inline-block text-truncate"
                style={{
                  maxWidth: "100%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {row.PT_TYPE && row.PT_TYPE.length > 0
                  ? row.PT_TYPE
                  : "Select types"}
              </span>
            </button>

            {dropdownState.ptTypeDropdownOpen && (
              <div className="dropdown-menu show p-2 border">
                <input
                  type="text"
                  className="form-control mb-2"
                  placeholder="Search..."
                  value={dropdownState.searchQuery || ""}
                  onChange={(e) =>
                    setSearchQuery(rowIndex, e.target.value, key)
                  }
                />
                <div
                  style={{
                    maxHeight: "200px",
                    overflowY: "auto",
                    width: "170px",
                  }}
                >
                  {filteredTypeOptions.length > 0 ? (
                    filteredTypeOptions.map((opt, idx) => {
                      const selectedValues = row.PT_TYPE
                        ? row.PT_TYPE.split(",")
                        : [];
                      const isChecked = selectedValues.includes(opt);

                      return (
                        <div className="form-check" key={idx}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`checkbox-${rowIndex}-PT_TYPE-${opt}`}
                            value={opt}
                            checked={isChecked}
                            onChange={() =>
                              toggleCheckbox(rowIndex, "PT_TYPE", opt)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`checkbox-${rowIndex}-PT_TYPE-${opt}`}
                          >
                            {opt}
                          </label>
                        </div>
                      );
                    })
                  ) : (
                    <div className="dropdown-item text-muted">No matches</div>
                  )}
                </div>
                <button
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => setAddNewType(!addNewType)}
                >
                  Add New Machine
                </button>
              </div>
            )}
          </div>
        );
      }

      case "PT_FROM":
      case "PT_TO": {
        const isDropdownOpen =
          key === "PT_FROM"
            ? dropdownState.ptFromDropdownOpen
            : dropdownState.ptToDropdownOpen;
        const toggleKey =
          key === "PT_FROM" ? "ptFromDropdownOpen" : "ptToDropdownOpen";
        const filteredFTOptions = options[key].filter((opt) =>
          opt
            .toLowerCase()
            .includes(
              (key === "PT_FROM"
                ? dropdownState.fromStation
                : dropdownState.toStation || ""
              ).toLowerCase()
            )
        );

        return (
          <div className="dropdown" onClick={(e) => e.stopPropagation()}>
            <button
              className="btn btn-outline-secondary dropdown-toggle w-100 text-start"
              type="button"
              onClick={() =>
                toggleDropdown(rowIndex, toggleKey, !isDropdownOpen)
              }
            >
              <span
                className="d-inline-block text-truncate"
                style={{
                  maxWidth: "100%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {row[key] && row[key].length > 0 ? row[key] : "Select options"}
              </span>
            </button>

            {isDropdownOpen && (
              <div className="dropdown-menu show p-2 border">
                <input
                  type="text"
                  className="form-control mb-2"
                  placeholder="Search From station..."
                  value={
                    key === "PT_FROM"
                      ? dropdownState.fromStation
                      : dropdownState.toStation || ""
                  }
                  onChange={(e) =>
                    setSearchQuery(rowIndex, e.target.value, key)
                  }
                />
                <div
                  style={{
                    maxHeight: "200px",
                    overflowY: "auto",
                    width: "170px",
                  }}
                >
                  {filteredFTOptions.length > 0 ? (
                    filteredFTOptions.map((opt, idx) => {
                      const selectedValues = row[key]
                        ? row[key].split(",")
                        : [];
                      const isChecked = selectedValues.includes(opt);

                      return (
                        <div className="form-check" key={idx}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`checkbox-${rowIndex}-${key}-${opt}`}
                            value={opt}
                            checked={isChecked}
                            onChange={() => toggleCheckbox(rowIndex, key, opt)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`checkbox-${rowIndex}-${key}-${opt}`}
                          >
                            {opt}
                          </label>
                        </div>
                      );
                    })
                  ) : (
                    <div className="dropdown-item text-muted">No matches</div>
                  )}
                </div>
              </div>
            )}
          </div>
        );
      }

      case "REMARK":
        return (
          <input
            type="text"
            className="form-control"
            value={row[key]}
            onChange={(e) => handleChange(rowIndex, key, e.target.value)}
          />
        );

      case "PT_REASON":
      case "PT_WASTAGE_TRAIN_TYPE":
        return (
          <select
            className="form-control"
            value={row[key] || ""}
            onChange={(e) => toggleCheckbox(rowIndex, key, e.target.value)}
          >
            <option hidden value="">
              Select {key === "PT_REASON" ? "Reason" : "Train Type"}
            </option>
            {options[key].map((opt, idx) => (
              <option key={idx} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        );

      default:
        return null;
    }
  };

  const addRow = () => {
    setRows((prev) => [...prev, getEmptyRow()]);
    setDropdownStates((prev) => [
      ...prev,
      {
        ptTypeDropdownOpen: false,
        ptFromDropdownOpen: false,
        ptToDropdownOpen: false,
        searchQuery: "",
        toStation: "",
        fromStation: "",
      },
    ]);
  };

  const removeRow = (index) => {
    if (rows.length === 1) {
      toast.error("At least one row is required");
      return;
    }
    setRows((prev) => prev.filter((_, i) => i !== index));
    setDropdownStates((prev) => prev.filter((_, i) => i !== index));
  };

  const handleClear = () => {
    setRows([getEmptyRow()]);
    setDropdownStates([
      {
        ptTypeDropdownOpen: false,
        ptFromDropdownOpen: false,
        ptToDropdownOpen: false,
        searchQuery: "",
        toStation: "",
        fromStation: "",
      },
    ]);
  };
  const handleSubmit = async () => {
    try {
      const response = await fetch(`${urlBlockPrefix}insertPathData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(rows),
      });

      const result = await response.json();
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${result.status}`);
      }
      toast.success("Successfully submitted all rows!");
      handleClear();
    } catch (error) {
      toast.error("Error submitting data.");
    }
  };

  return (
    <div
      onClick={() => {
        setDropdownStates((prevStates) =>
          prevStates.map((state) => ({
            ...state,
            ptTypeDropdownOpen: false,
            ptFromDropdownOpen: false,
            ptToDropdownOpen: false,
            searchQuery: "",
            toStation: "",
            fromStation: "",
          }))
        );
      }}
    >
      <h5 className="bg-dark text-white text-center p-2">
        Insert Data In Path Wastage
      </h5>

      <div className="d-flex justify-content-center m-2">
        <input
          type="date"
          className="form-control"
          style={{ maxWidth: "200px" }}
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
        />
        <button className="btn btn-outline-dark ms-2" onClick={addRow}>
          + Add Row
        </button>
      </div>
      <div className="d-flex justify-content-center">
        <div style={{ overflowX: "auto" }}>
          <div
            style={{
              width: "1550px",
              height: "500px",
            }}
          >
            <div className="border mb-3">
              <div className="d-flex mb-2 bg-dark">
                <div
                  className="bg-dark text-white text-center"
                  style={{ width: "50px", fontWeight: "bold", padding: "5px" }}
                >
                  Sr No.
                </div>
                {keys.map((key, idx) => (
                  <div
                    key={idx}
                    className="bg-dark text-white text-center"
                    style={{
                      width: "200px",
                      fontWeight: "bold",
                      textTransform: "capitalize",
                      padding: "5px",
                    }}
                  >
                    {key.replace("pt_", "").replace("_", " ")}
                  </div>
                ))}
                <div
                  className="bg-dark text-white text-center"
                  style={{ width: "50px", fontWeight: "bold", padding: "5px" }}
                >
                  Action
                </div>
              </div>

              {rows.map((row, rowIndex) => (
                <div key={rowIndex} className="d-flex mb-2 align-items-center">
                  <div
                    className="text-center"
                    style={{ width: "50px", padding: "5px" }}
                  >
                    {rowIndex + 1}
                  </div>
                  {keys.map((key, idx) => (
                    <div key={idx} style={{ width: "200px", padding: "5px" }}>
                      {renderInput(rowIndex, key)}
                    </div>
                  ))}
                  <div
                    style={{ width: "50px", padding: "5px" }}
                    className="ms-4"
                  >
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeRow(rowIndex);
                      }}
                      title="Remove Row"
                    >
                      &times;
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="mb-3 text-center"></div>

      <div className="text-center mt-4">
        <button
          className="btn btn-outline-danger m-2 px-5"
          onClick={handleClear}
        >
          Clear All
        </button>
        <button
          className="btn btn-outline-success m-2 px-5"
          onClick={handleSubmit}
        >
          Insert Data
        </button>
      </div>
      {addNewType && (
        <AddNewType
          setAddNewType={setAddNewType}
          rawMData={rawMData}
          setDataUpdated={setDataUpdated}
        />
      )}
    </div>
  );
};

export default PathWastageinsertion;
